import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'components/View'
import CircularProgress from 'components/CircularProgress'
import TextBody from 'components/TextBody'
import { useTheme } from 'modules/styles'
import useSelector from 'modules/component/utils/hooks/useSelector'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { getFormScoreColorName } from 'modules/exercise-form-check/utils/get-form-score-color-name'

/**
 * Score card component for exercise form check results
 * @param {string} emoji - Emoji icon to display
 * @param {string} label - Score label text
 * @param {number} score - Score value (0-100)
 * @param {Function} onClick - Click handler
 * @returns {Element}
 */
export default function ScoreCard ({
  emoji,
  label,
  score,
  onClick
}) {
  const theme = useTheme()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const colorName = getFormScoreColorName(score)
  const color = theme.colors[colorName]

  return (
    <View
      onClick={onClick}
      p={2}
      bdr
      bgc='background'
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '1em',
        minWidth: isSmallScreen ? 'calc(44% - 0.5rem)' : 'calc(47% - 0.5rem)',
        border: `1px solid ${theme.colors.border}`,
        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)'
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)'
        e.currentTarget.style.boxShadow = 'none'
      }}
    >
      {/* Emoji */}
      <View style={{ fontSize: '2em', flexShrink: 0 }}>
        {emoji}
      </View>

      {/* Label */}
      <View style={{ flex: 1 }}>
        <TextBody style={{ fontWeight: 'bold', margin: 0 }}>
          {label}
        </TextBody>
      </View>

      {/* Circular Progress */}
      <View style={{ flexShrink: 0 }}>
        <CircularProgress
          percentage={score}
          size={50}
          strokeWidth={4}
          color={color}
        />
      </View>
    </View>
  )
}

ScoreCard.propTypes = {
  emoji: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  onClick: PropTypes.func
}
